import React from 'react';
import { connect } from 'react-redux';
import { DBTextFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class PatientCareCenterNoteObjectiveMcKenzieTriplePanel extends React.Component {

    render() {

        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText={'McKenzie - Test Movements - ' + this.props.panel.MOPLABEL} />
                <label title={this.props.panel.MOPHOVER} className={styles.mckenzie_label}>{this.props.panel.MOPLABEL}</label>
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field={this.props.panel.MOPCOLUMNPREFIX + 'DURING'}
                    className={styles.mckenzie_triple_field}
                    title='produces, abolishes, increases, decreases, no effect, centralising, peripheralising'
                />
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field={this.props.panel.MOPCOLUMNPREFIX + 'AFTER'}
                    className={styles.mckenzie_triple_field}
                    title='better, worse, no better, no worse, centralised, peripheralised'
                />
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field={this.props.panel.MOPCOLUMNPREFIX + 'MECHRESP'}
                    className={styles.mckenzie_triple_field}
                    title='increased ROM, decreased ROM, no effect'
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));
    let panel = state.entities.masterData.PTMASTEROBJECTIVEPANELS[ownprops.panelId];
    let flagged = false;

    if (state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'DURING'] ||
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'AFTER'] ||
        state.entities.notes.PTOBJECTIVEROM[rono][panel.MOPCOLUMNPREFIX + 'MECHRESP']) {
        flagged = true;
    }

    return {
        noteId: noteId,
        rono: rono,
        panel: panel,
        flagged: flagged
    };
}

const connectedPatientCareCenterNoteObjectiveMcKenzieTriplePanel = connect(mapStateToProps)(PatientCareCenterNoteObjectiveMcKenzieTriplePanel);
export { connectedPatientCareCenterNoteObjectiveMcKenzieTriplePanel as PatientCareCenterNoteObjectiveMcKenzieTriplePanel };


